import { uploadValidMassLEData } from "actions/CarrierAgreementMgmt/LeasedEquipment";
import { useMutation } from "react-query";
const useSaveMassUpload = () => {
  return useMutation(uploadValidMassLEData);
};

export default useSaveMassUpload;
